import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  changes,
  createChange,
  createIncident,
  createProjects,
  createTopDeskCustomer,
  incidents,
  timechimpCustomers,
} from "../endpoints";
import useFetch from "../hooks/useFetch";

interface data {
  number: string;
  description: string;
}

interface Props {
  name: string;
}

const ManagementLayout = () => {
  const [isChangeCreationVisible, setIsChangeCreationVisible] = useState(false);
  const [isIncidentCreationVisible, setIsIncidentCreationVisible] =
    useState(false);
  const [isProjectOpen, setisProjectOpen] = useState(false);
  const [isTopDeskOpen, setIsTopDeskOpen] = useState(false);
  const [change, setChange] = useState("");
  const [incident, setIncident] = useState("");
  const [data, setData] = useState<data[]>([]);
  const [incidentData, setIncidentData] = useState<data[]>([]);
  const { data: customerData } = useFetch<Props>(timechimpCustomers);
  const [selectedCustomer, setSelectedCustomer] = useState<string>("");
  const apiKey = process.env.REACT_APP_API_KEY;
  const baseUrl = process.env.REACT_APP_BASE_URL;

  //   Create change
  useEffect(() => {
    const fetchData = () => {
      axios
        .get(baseUrl + changes, {
          headers: {
            Authorization: apiKey,
          },
        })
        .then((response) => {
          setData(response.data.results);
        })
        .catch((error) => {
          console.error("There was an error!", error.response);
        });
    };

    fetchData();

    const intervalId = setInterval(fetchData, 600000);

    return () => clearInterval(intervalId);
  }, [apiKey, baseUrl]);

  useEffect(() => {
    const fetchIncidentData = () => {
      axios
        .get(baseUrl + incidents, {
          headers: {
            Authorization: apiKey,
          },
        })
        .then((response) => {
          setIncidentData(response.data.results);
        })
        .catch((error) => {
          console.error("There was an error!", error.response);
        });
    };

    fetchIncidentData();

    const intervalId = setInterval(fetchIncidentData, 600000);

    return () => clearInterval(intervalId);
  }, [apiKey, baseUrl]);

  const handleChangeOpen = () => {
    setIsChangeCreationVisible(!isChangeCreationVisible);
  };

  const handleIncidentOpen = () => {
    setIsIncidentCreationVisible(!isIncidentCreationVisible);
  };

  const handleChangeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setChange(e.target.value);
  };

  const handleIncidentChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setIncident(e.target.value);
  };

  const sendData = () => {
    axios
      .post(baseUrl + createChange, null, {
        params: { changeNumber: change },
        headers: {
          Authorization: apiKey,
        },
      })
      .catch((error) => {
        console.error("There was an error!", error.response);
      });

    handleChangeOpen();
  };

  const sendIncidentData = () => {
    axios
      .post(baseUrl + createIncident, null, {
        params: { incidentNumber: incident },
        headers: {
          Authorization: apiKey,
        },
      })
      .catch((error) => {
        console.error("There was an error!", error.response);
      });

    handleIncidentOpen();
  };

  //   Create project
  const toggleProject = () => {
    setisProjectOpen(!isProjectOpen);
  };

  const handleButtonClick = async () => {
    if (selectedCustomer) {
      try {
        await axios.post(baseUrl + createProjects, null, {
          params: { companyName: selectedCustomer },
          headers: {
            Authorization: apiKey,
          },
        });
        setisProjectOpen(!isProjectOpen);
        setSelectedCustomer("");
        alert("Projecten succesvol aangemaakt");
      } catch (error) {
        console.error("Error posting data:", error);
      }
    } else {
      console.warn("No customer selected.");
    }
  };

  const handleSelectCustomer = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedCustomer(event.target.value);
  };

  //   Create customer in TopDesk
  const createTopDesk = async () => {
    try {
      await axios.post(baseUrl + createTopDeskCustomer, null, {
        params: { companyName: selectedCustomer },
        headers: {
          Authorization: apiKey,
        },
      });
      setIsTopDeskOpen(!isTopDeskOpen);
      setSelectedCustomer("");
      alert("Klant succesvol aangemaakt in TopDesk");
    } catch (error) {
      alert("Klant bestaat al in TopDesk");
      console.error("Error posting data:", error);
    }
  };

  const toggleTopDesk = () => {
    setIsTopDeskOpen(!isTopDeskOpen);
  };

  return (
    <>
      <div className="overflow-hidden w-full">
        {/* Header */}
        <div>
          <div className="flex justify-between">
            {/* Header Text */}
            <div>
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center">
                <h1 className="font-bold text-3xl sm:text-4xl">Management</h1>
              </div>
              <p className="mt-4">
                Hier een overzicht van alle Management knoppen
              </p>
            </div>
          </div>

          {/* Data Table */}
          <div className="p-8 bg-white  rounded-xl mt-6 w-full overflow-auto flex flex-row flex-wrap justify-evenly">
            <div className="w-[40%] bg-gray-200 rounded-xl mb-2 p-2">
              <b>Maak wijziging aan in TimeChimp</b>
              <p>Deze knop maakt een wijziging aan in Timechimp op basis van de geselecteerde wijziging uit Topdesk.</p>
              <button
              className="p-3 transition-transform duration-300 ease-in-out text-white bg-gradient-to-r from-[#4bbfed] to-[#008fc7] rounded-2xl w-auto cursor-pointer border-none hover:scale-105"
              onClick={handleChangeOpen}
              >
                Create change
              </button>
            </div>
            
            <div className="w-[40%] bg-gray-200 rounded-xl mb-2 p-2">
              <b>Maak melding aan in TimeChimp</b>
              <p>Deze knop maakt een melding aan in Timechimp op van de geselecteerde melding uit Topdesk.</p>
              <button
                className="p-3 transition-transform duration-300 ease-in-out text-white bg-gradient-to-r from-[#4bbfed] to-[#008fc7] rounded-2xl w-auto cursor-pointer border-none hover:scale-105"
                onClick={handleIncidentOpen}
              >
                Create incident
              </button>
            </div>

            {/* Create project button */}
            <div className="w-[40%] bg-gray-200 rounded-xl mb-2 p-2">
              <b>Maak project aan in TimeChimp</b>
              <p>Deze knop maakt de projecten aan voor een klant in Timechimp.</p>
              <button
                className="p-3 transition-transform duration-300 ease-in-out text-white bg-gradient-to-r from-[#4bbfed] to-[#008fc7] rounded-2xl w-auto cursor-pointer border-none hover:scale-105"
                onClick={toggleProject}
              >
                Create projects
              </button>
            </div>

            {/* Create customer in TopDesk button */}
            <div className="w-[40%] bg-gray-200 rounded-xl mb-2 p-2">
              <b>Maak klant aan in TopDesk</b>
              <p>Deze knop maakt een klant aan in Topdesk op basis van de klant die u selecteerd uit Timechimp.</p>
              <button
                className="p-3 transition-transform duration-300 ease-in-out text-white bg-gradient-to-r from-[#4bbfed] to-[#008fc7] rounded-2xl w-auto cursor-pointer border-none hover:scale-105"
                onClick={toggleTopDesk}
              >
                Maak aan in TopDesk
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Create change form */}
      {isChangeCreationVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div
            className={`bg-[#13283F] p-6 rounded-lg shadow-lg w-full max-w-md relative z-50 transition-all duration-500 ease-in-out flex flex-col justify-center`}
          >
            <div>
              <button
                onClick={handleChangeOpen}
                className="absolute top-4 right-4 text-white hover:text-gray-400"
              >
                ✕
              </button>
              <h2 className="text-2xl font-semibold mb-2 mt-6 text-white">
                Maak wijziging aan in TimeChimp
              </h2>
              <select
                className="w-full p-2 mb-4 rounded-[10px] text-white border-2 border-[#4bbfed] bg-[#4d4d4d]"
                onChange={handleChangeChange}
              >
                <option value="" disabled selected>
                  Selecteer een wijziging
                </option>
                {data.map((change, index) => (
                  <option value={change.number}>
                    {change.number}
                    <p>: </p>
                    {change.description}
                  </option>
                ))}
              </select>
              <button
                className="px-6 py-2 bg-gradient-to-r from-[#4BBFED] to-[#008FC7] text-white rounded-lg text-sm sm:text-base transition-all duration-300 ease-in-out hover:scale-105 w-full"
                onClick={sendData}
              >
                Maak wijziging
              </button>
            </div>
          </div>
        </div>
      )}

      {isIncidentCreationVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div
            className={`bg-[#13283F] p-6 rounded-lg shadow-lg w-full max-w-md relative z-50 transition-all duration-500 ease-in-out flex flex-col justify-center`}
          >
            <div>
              <button
                onClick={handleIncidentOpen}
                className="absolute top-4 right-4 text-white hover:text-gray-400"
              >
                ✕
              </button>
              <h2 className="text-2xl font-semibold mb-2 mt-6 text-white">
                Maak melding aan in TimeChimp
              </h2>
              <select
                className="w-full p-2 mb-4 rounded-[10px] text-white border-2 border-[#4bbfed] bg-[#4d4d4d]"
                onChange={handleIncidentChange}
              >
                <option value="" disabled selected>
                  Selecteer een melding
                </option>
                {incidentData.map((incident, index) => (
                  <option value={incident.number}>
                    {incident.number}
                    <p>: </p>
                    {incident.description}
                  </option>
                ))}
              </select>
              <button
                className="px-6 py-2 bg-gradient-to-r from-[#4BBFED] to-[#008FC7] text-white rounded-lg text-sm sm:text-base transition-all duration-300 ease-in-out hover:scale-105 w-full"
                onClick={sendIncidentData}
              >
                Maak melding
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Create project form */}
      {isProjectOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div
            className={`bg-[#13283F] p-6 rounded-lg shadow-lg w-full max-w-md relative z-50 transition-all duration-500 ease-in-out flex flex-col justify-center`}
          >
            <div>
              <button
                onClick={toggleProject}
                className="absolute top-4 right-4 text-white hover:text-gray-400"
              >
                ✕
              </button>
              <h2 className="text-2xl font-semibold mb-2 mt-6 text-white">
                Maak projecten voor klant aan in TimeChimp
              </h2>
              <select
                className="w-full p-2 mb-4 rounded-[10px] text-white border-2 border-[#4bbfed] bg-[#4d4d4d]"
                value={selectedCustomer}
                onChange={handleSelectCustomer}
              >
                <option value="" disabled>
                  Selecteer een klant
                </option>
                {customerData.map((item, index) => (
                  <option key={index} value={item.name}>
                    {item.name}
                  </option>
                ))}
              </select>
              <button
                className="px-6 py-2 bg-gradient-to-r from-[#4BBFED] to-[#008FC7] text-white rounded-lg text-sm sm:text-base transition-all duration-300 ease-in-out hover:scale-105 w-full"
                onClick={handleButtonClick}
              >
                Voeg projecten toe
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Create customer in TopDesk form */}
      {isTopDeskOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div
            className={`bg-[#13283F] p-6 rounded-lg shadow-lg w-full max-w-md relative z-50 transition-all duration-500 ease-in-out flex flex-col justify-center`}
          >
            <div>
              <button
                onClick={toggleTopDesk}
                className="absolute top-4 right-4 text-white hover:text-gray-400"
              >
                ✕
              </button>
              <h2 className="text-2xl font-semibold mb-2 mt-6 text-white">
                Maak klant aan in TopDesk
              </h2>
              <select
                className="w-full p-2 mb-4 rounded-[10px] text-white border-2 border-[#4bbfed] bg-[#4d4d4d]"
                value={selectedCustomer}
                onChange={handleSelectCustomer}
              >
                <option value="" disabled>
                  Selecteer een klant
                </option>
                {customerData.map((item, index) => (
                  <option key={index} value={item.name}>
                    {item.name}
                  </option>
                ))}
              </select>
              <button
                className="px-6 py-2 bg-gradient-to-r from-[#4BBFED] to-[#008FC7] text-white rounded-lg text-sm sm:text-base transition-all duration-300 ease-in-out hover:scale-105 w-full"
                onClick={createTopDesk}
              >
                Voeg projecten toe
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ManagementLayout;
